import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services';
import { UserFacade } from '../store/user/user.facade';
import { ConsoleRoute } from '../utils/home-route.util';

export const authGuard: CanActivateFn = (route, state) => {
  const userFacade = inject(UserFacade);
  const router = inject(Router);
  const authService = inject(AuthService);

  const isChangePasswordRoute = state.url.startsWith(ConsoleRoute.ChangePassword);

  if (userFacade.requiresPasswordChange() && !isChangePasswordRoute) {
    return router.createUrlTree([ ConsoleRoute.ChangePassword ]);
  }

  if (userFacade.isAuthenticated()) {
    return true;
  }

  if (userFacade.user()) {
    userFacade.validateTokenWhenNeeded();
    return true;
  }

  if (authService.hasStoredToken()) {
    userFacade.validateTokenWhenNeeded();
    return true;
  }

  return router.createUrlTree([ ConsoleRoute.Login ], { queryParams: { returnUrl: state.url } });
};
